import { testimonials } from '@/mocks/site';

const principles = [
  {
    icon: 'ri-filter-3-line',
    title: '只梳理，不生产爆料',
    desc: '我们不制造新料，只把公开可见的信息按时间顺序整理成可读的版本，让脉络自己说话。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '核实优先，状态明示',
    desc: '每条记录都标注「进行中 / 已反转 / 已澄清 / 官方回应」，未核实的内容会明确提示。',
  },
  {
    icon: 'ri-history-line',
    title: '保留反转，不删旧记录',
    desc: '反转后我们不会悄悄抹掉之前的版本，而是保留对照，让你看清变化发生的节点。',
  },
  {
    icon: 'ri-lock-2-line',
    title: '保护隐私，抵制人肉',
    desc: '涉及个人隐私、住址与联系方式的内容一律不做收录，也请投稿时不要提供相关信息。',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5 lg:items-center">
          <div className="lg:col-span-2">
            <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="h-64 w-full overflow-hidden md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=stylized%20warm%20editorial%20desk%20scene%20with%20notebook%20timeline%20sketches%2C%20amber%20desk%20lamp%20glow%2C%20deep%20red%20accents%2C%20soft%20paper%20texture%2C%20abstract%20no%20text%2C%20cinematic%20mood&width=1200&height=800&seq=gt-about-01&orientation=landscape"
                  alt="瓜田情报局编辑台，把碎片信息整理成时间线的工作场景"
                  title="瓜田情报局 - 内容整理与核实流程"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex items-center gap-3 bg-primary-500 px-5 py-4">
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600">
                  <i className="ri-radar-line text-xl" />
                </span>
                <div>
                  <p className="font-heading text-base font-bold text-background-50">瓜田情报局</p>
                  <p className="mt-0.5 text-xs text-primary-100">一个瓜从爆出到尘埃落定，全程追踪不遗漏</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <span className="text-xs font-medium tracking-[0.2em] text-secondary-600">ABOUT US</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">关于我们</h2>
            <div className="mt-5 flex flex-col gap-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              <p>
                瓜田情报局是一个专注「后续进展」的热点追踪站。我们不做耸动的标题党，而是把散落在论坛、社交平台和官方声明里的信息，
                按时间顺序还原成一条可以阅读、可以对照的事件线。
              </p>
              <p>
                站点定位很明确：给习惯蹲后续的人一个不用来回翻十几个账号的地方。最新回应、剧情反转、当事人发声、第二弹更新，
                都能在同一条时间线上找到位置，并且保留此前版本，方便你自己判断。
              </p>
              <p>
                我们的内容原则只有一句：<strong className="font-medium text-foreground-900">把事实摆清楚，把判断留给读者。</strong>
                所有涉及个人隐私的内容不作收录，也欢迎你通过纠错通道帮我们修正偏差。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">内容原则</h3>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            这四条决定了我们收录什么、怎么标注、以及反转之后怎么处理旧内容。
          </p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h4>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16">
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
            <div>
              <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">用户口碑</h3>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                来自长期蹲后续的读者反馈，看看他们是怎么用这个站的。
              </p>
            </div>
            <span className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800">
              <i className="ri-user-voice-line" />
              累计 2.4 万条读者反馈
            </span>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {testimonials.map((item) => (
              <blockquote
                key={item.name}
                className="rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <span className="flex h-8 w-8 items-center justify-center text-accent-600">
                  <i className="ri-double-quotes-l text-2xl" />
                </span>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.text}</p>
                <footer className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                    {item.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                    <p className="text-xs text-foreground-500">{item.role}</p>
                  </div>
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}